import { useRef } from 'react';
import { TbUpload } from 'react-icons/tb';
import { ButtonTernary } from 'components/molecules/Button';
import styled from 'styled-components';

const Media = styled.img`
  object-fit: cover;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  overflow: hidden;
`;

const STORAGE_URL =
  process.env.NODE_ENV === 'development'
    ? `${process.env.REACT_APP_API_URL}/images/`
    : 'https://app.fonselp.com/storage/images/';

const ProfileImageUpload = ({ currentImage, onImageChange, userImage, name }) => {
  const fileInputRef = useRef(null);

  const onFileSelected = ({ target }) => {
    console.log(target);
    if (target.files && target.files.length) {
      const file = target.files[0];
      onImageChange(file);
    }
  };

  return (
    <div className={'d-flex flex-column align-items-center'}>
      {(userImage || currentImage) && (
        <Media
          src={currentImage ? URL.createObjectURL(currentImage) : `${STORAGE_URL}${userImage}`}
          alt={name}
          className="rounded-circle"
        />
      )}
      <ButtonTernary onClick={() => fileInputRef.current?.click()} className="ml-2 my-4" type="button">
        <span className="mr-2">Cargar foto</span> <TbUpload />
      </ButtonTernary>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/png, image/gif, image/jpeg"
        style={{ display: 'none' }}
        onChange={onFileSelected}
      />
    </div>
  );
};

export default ProfileImageUpload;
